import React, { Component } from "react";
export default class SentenceCompletion extends Component {
  render() {
    var {
      sentence_completion_q1_s1,
      sentence_completion_q1_s2,
      sentence_completion_q1_s3,
      sentence_completion_q1_s4,
      sentence_completion_q2_s1,
      sentence_completion_q2_s2,
      sentence_completion_c1,
      sentence_completion_c2,
      sentence_completion_q2_s3,
      sentence_completion_c3,
      sentence_completion_q2_s4,
      sentence_completion_c4,
      sentence_completion_q2_s5,
      sentence_completion_c5,
      sentence_completion_q2_s6,
      sentence_completion_c6,
      sentence_completion_score,
    } = this.props.data;
    return (
      <div className="row border border-dark bg-white">
        <div className="col-lg-12">
          <div className="row mt-3">
            <div className="col-lg-6">
              <p className="ml-3 fs-19">
                1. He phoned up the restaurant to reserve a
              </p>
              <input
                disabled
                type="text"
                name="sentence_completion_q1_s1"
                value={sentence_completion_q1_s1}
                className="ecas-input-field col-lg-10 ml-3 sentence-completion-input"
              />
            </div>
            <div className="col-lg-6">
              <p className="ml-3 fs-19">
                2. When she got up in the morning, the sun was
              </p>
              <input
                disabled
                type="text"
                name="sentence_completion_q1_s2"
                value={sentence_completion_q1_s2}
                className="ecas-input-field col-lg-10 ml-3 sentence-completion-input"
              />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-lg-6">
              <p className="ml-3 fs-19">
                1. He phoned up the restaurant to reserve a
              </p>
              <input
                disabled
                type="text"
                name="sentence_completion_q1_s3"
                value={sentence_completion_q1_s3}
                className="ecas-input-field col-lg-10 ml-3 sentence-completion-input"
              />
            </div>
            <div className="col-lg-6">
              <p className="ml-3 fs-19">
                2. When she got up in the morning, the sun was
              </p>
              <input
                disabled
                type="text"
                name="sentence_completion_q1_s4"
                value={sentence_completion_q1_s4}
                className="ecas-input-field col-lg-10 ml-3 sentence-completion-input"
              />
            </div>
          </div>
          <hr />
          <div className="col-lg-6">
            <br />
            <span className="fs-19">Score </span>
            <input
              type="number"
              disabled
              name="sentence_completion_score"
              value={sentence_completion_score}
              className="ecas-input-field"
              placeholder="Score"
            />
          </div>
        </div>
      </div>
    );
  }
}
